var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaseEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67867 7.45626C1.53633 7.30167 1.40986 7.16002 1.30022 7.03448C1.40986 6.90895 1.53633 6.7673 1.67867 6.61271C2.26166 5.97955 3.10493 5.1359 4.14406 4.29437C6.24929 2.58948 9.02664 1 12 1C14.9734 1 17.7507 2.58948 19.8559 4.29437C20.8951 5.1359 21.7383 5.97955 22.3213 6.61271C22.4637 6.7673 22.5901 6.90895 22.6998 7.03448C22.5901 7.16002 22.4637 7.30167 22.3213 7.45626C21.7383 8.08941 20.8951 8.93307 19.8559 9.7746C17.7507 11.4795 14.9734 13.069 12 13.069C9.02664 13.069 6.24929 11.4795 4.14406 9.7746C3.10493 8.93307 2.26166 8.08941 1.67867 7.45626Z",
    stroke: "#22E295",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 12.4139C14.9713 12.4139 17.3797 10.0055 17.3797 7.03458C17.3797 4.06367 14.9713 1.65527 12.0004 1.65527C9.02949 1.65527 6.62109 4.06367 6.62109 7.03458C6.62109 10.0055 9.02949 12.4139 12.0004 12.4139ZM12.0004 9.93116C13.6001 9.93116 14.8969 8.63433 14.8969 7.03461C14.8969 5.43488 13.6001 4.13805 12.0004 4.13805C10.4006 4.13805 9.10381 5.43488 9.10381 7.03461C9.10381 8.63433 10.4006 9.93116 12.0004 9.93116Z",
    fill: "#22E295"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 12.4139C14.9713 12.4139 17.3797 10.0055 17.3797 7.03458C17.3797 4.06367 14.9713 1.65527 12.0004 1.65527C9.02949 1.65527 6.62109 4.06367 6.62109 7.03458C6.62109 10.0055 9.02949 12.4139 12.0004 12.4139ZM12.0004 9.93116C13.6001 9.93116 14.8969 8.63433 14.8969 7.03461C14.8969 5.43488 13.6001 4.13805 12.0004 4.13805C10.4006 4.13805 9.10381 5.43488 9.10381 7.03461C9.10381 8.63433 10.4006 9.93116 12.0004 9.93116Z",
    fill: "#22E295"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseEye);
export default __webpack_public_path__ + "static/media/lease-eye.125f387c.svg";
export { ForwardRef as ReactComponent };